var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c(Component,{tag:"component",attrs:{"socket":slotProps.socket}})]}}],null,true)})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }